import { ReactComponent as FacebookIcon } from './images/facebook.svg';
import { ReactComponent as LinkedinIcon } from './images/linkedin.svg';
import { ReactComponent as TwitterIcon } from './images/twitter.svg';

import styles from './SocialMedia.module.scss';

type SocialMediaProps = {
	color?: string;
	showTitle?: boolean;
};

export default function SocialMedia({ color = 'white', showTitle = false }: SocialMediaProps) {
	return (
		<>
			{showTitle && <div className={styles.title}>Join us on our social media</div>}
			<div className={styles['social-media']}>
				<a
					href="https://twitter.com/Safe_Esteem"
					className={styles.icon}
					style={{ borderColor: color }}
					aria-label="Twitter"
				>
					<TwitterIcon fill={color} />
				</a>
				<a
					href="https://www.facebook.com/Safe.esteem/"
					className={styles.icon}
					style={{ borderColor: color }}
					aria-label="Facebook"
				>
					<FacebookIcon fill={color} />
				</a>
				<a
					href="https://www.linkedin.com/company/safe-esteem/"
					className={styles.icon}
					style={{ borderColor: color }}
					aria-label="LinkedIn"
				>
					<LinkedinIcon fill={color} />
				</a>
			</div>
		</>
	);
}
